import { useState } from "react";
import { Link } from "react-router-dom";
import type { CarBrand } from "../data/carBrands";
import { getBrandLogo } from "../utils/brandLogos";

interface BrandCardProps {
  brand: CarBrand;
}

export const BrandCard = ({ brand }: BrandCardProps) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const logoSrc = getBrandLogo(brand.id);

  return (
    <Link
      to={`/${brand.id}`}
      className="group w-full text-left bg-card border border-border rounded-2xl p-5 transition-all duration-200 hover:border-foreground hover:shadow-md focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background active:scale-[0.98] block"
      aria-label={`Veure models de ${brand.name}`}
    >
      <div className="flex flex-col items-center justify-center gap-3">
        <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
          {!imageError ? (
            <div className="w-full h-full rounded-xl bg-white border border-transparent dark:border-white/15 flex items-center justify-center p-2">
              <img
                src={logoSrc}
                alt={`${brand.name} logo`}
                className="w-full h-full object-contain"
                onError={handleImageError}
              />
            </div>
          ) : (
            <span className="text-4xl sm:text-5xl">{brand.logo}</span>
          )}
        </div>
        <div className="text-center w-full">
          <h3 className="text-sm sm:text-base font-semibold mb-0.5 text-foreground group-hover:text-muted-foreground line-clamp-1">
            {brand.name}
          </h3>
          <div className="mt-2 flex items-center justify-center gap-2">
            <div className="inline-flex items-center justify-center px-2.5 py-1 bg-secondary rounded-full">
              <span className="text-xs font-medium text-secondary-foreground">
                {brand.models.length}
              </span>
            </div>
            {brand.discontinuedModels && brand.discontinuedModels.length > 0 && (
              <div className="inline-flex items-center justify-center px-2.5 py-1 bg-red-100 dark:bg-red-950 rounded-full">
                <span className="text-xs font-medium text-red-700 dark:text-red-300">
                  {brand.discontinuedModels.length}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

